import { ReactNode } from 'react';

interface IInvoiceProps {
  readonly children: ReactNode;
}

export function Invoice(props: IInvoiceProps) {
  return <section className="space-y-lg">{props.children}</section>;
}
